import type { StreakLeaderboardEntry, StreakSnapshot } from '@/hooks/useStreaks';

export function StreakSheet({
  open,
  streak,
  leaderboard,
  onClose,
}: {
  open: boolean;
  streak: StreakSnapshot | null;
  leaderboard: StreakLeaderboardEntry[];
  onClose: () => void;
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] grid place-items-end bg-black/40 p-4 sm:place-items-center" role="dialog" aria-label="Streak">
      <div className="w-full max-w-md rounded-3xl bg-white p-6 shadow-xl">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="text-sm font-bold uppercase tracking-wider text-[#C96B2B]">Daily streak</p>
            <h2 className="mt-1 text-3xl font-black">{streak?.current_streak ?? 0} days</h2>
            <p className="mt-1 text-sm text-slate-500">Longest: {streak?.longest_streak ?? 0}</p>
          </div>
          <button type="button" onClick={onClose} className="font-bold text-[#2d7a13]">
            Close
          </button>
        </div>
        <p className="mt-4 text-sm text-slate-600">
          {streak?.qualified_today
            ? 'You already practiced today. Come back tomorrow to keep it going.'
            : 'Open a lesson, flashcard, or game today to qualify.'}
        </p>
        {leaderboard.length ? (
          <div className="mt-5">
            <h3 className="text-sm font-extrabold uppercase tracking-wider text-slate-500">Leaderboard</h3>
            <ol className="mt-2 space-y-2">
              {leaderboard.map((entry) => (
                <li key={`${entry.rank}-${entry.nickname || entry.display_name}`} className="flex gap-3 text-sm">
                  <strong className="w-6">{entry.rank}</strong>
                  <span className="flex-1 font-bold">{entry.display_name || entry.nickname || 'Learner'}</span>
                  <span>{entry.streak}</span>
                </li>
              ))}
            </ol>
          </div>
        ) : null}
      </div>
    </div>
  );
}
